import type { AudioStreamInfo } from '../types';
import { getMediaPlaybackOrigin } from './videoPlaybackUrl';

export function buildCourseAudioPlaybackUrl(
  audioId: string,
  streamInfo: Pick<AudioStreamInfo, 'streamUrl'> | null,
): string {
  const origin = getMediaPlaybackOrigin();
  const params = new URLSearchParams();

  let pathname = `/api/audios/${audioId}/stream`;
  if (streamInfo?.streamUrl) {
    try {
      const u = new URL(streamInfo.streamUrl);
      if (u.pathname) pathname = u.pathname;
      const fromServer = new URLSearchParams(u.search);
      fromServer.forEach((v, k) => {
        params.set(k, v);
      });
    } catch {
      /* use defaults */
    }
  }

  const token =
    typeof window !== 'undefined' ? localStorage.getItem('token')?.trim() : '';
  if (token && !params.has('token')) {
    params.set('token', token);
  }

  const qs = params.toString();
  return qs ? `${origin}${pathname}?${qs}` : `${origin}${pathname}`;
}
